import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface AuctionResource
    extends ng.resource.IResourceClass<ng.resource.IResource<any>> {
    get: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    bidLongTerm: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    bidShortTerm: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    config: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    tile: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    tiles: ng.resource.IResourceArrayMethod<ng.resource.IResource<any>>;
    calendars: ng.resource.IResourceMethod<
        ng.resource.IResource<{ [key: string]: AuctionCalendarDto[] }>
    >;
    comfortBids: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    comfortBid: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    deleteBid: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    updateComfortBid: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    createComfortBid: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    unifiedBids: ng.resource.IResourceArrayMethod<ng.resource.IResource<any>>;
    report: ng.resource.IResourceMethod<
        ng.resource.IResource<DataPageDto<AuctionDto>>
    >;
    getAuctionCompetitions: ng.resource.IResourceMethod<
        ng.resource.IResource<any>
    >;
    getReverseAuctions: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    reverseAuctionsReport: ng.resource.IResourceMethod<
        ng.resource.IResource<DataPageDto<AuctionDto>>
    >;
    reverseAuctionBid: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    capacityGraph: ng.resource.IResourceArrayMethod<ng.resource.IResource<any>>;
    comfortBidConfig: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
    orders: ng.resource.IResourceArrayMethod<ng.resource.IResource<any>>;
    cancelAuction: ng.resource.IResourceArrayMethod<ng.resource.IResource<any>>;
}

function auctionResource(
    $resource: ng.resource.IResourceService
): AuctionResource {
    return <AuctionResource>$resource(
        config.monolithApi + '/auctions',
        {},
        {
            get: {
                method: 'GET',
                url: config.monolithApi + '/auctions/:auctionId'
            },
            bidLongTerm: {
                method: 'POST',
                url: config.monolithApi + '/auctions/:auctionId/longTermOrder'
            },
            bidShortTerm: {
                method: 'POST',
                url: config.monolithApi + '/auctions/:auctionId/shortTermOrder'
            },
            config: {
                method: 'GET',
                url: config.monolithApi + '/auctions/:auctionId/config'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            tile: {
                method: 'GET',
                url: config.monolithApi + '/auctions/tile'
            },
            tiles: {
                method: 'GET',
                url: config.monolithApi + '/auctions/tiles',
                isArray: true
            },
            calendars: {
                method: 'GET',
                url: config.monolithApi + '/auctions/calendars'
            },
            comfortBids: {
                method: 'GET',
                url: config.monolithApi + '/auctions/comfortBids/dayAhead'
            },
            comfortBid: {
                method: 'GET',
                url: config.monolithApi + '/auctions/comfortBids/dayAhead/:id'
            },
            deleteBid: {
                method: 'DELETE',
                url: config.monolithApi + '/auctions/:id'
            },
            cancelAuction: {
                method: 'POST',
                url: config.monolithApi + '/auctions/:auctionId/cancel',
                params: {
                    auctionId: '@auctionId'
                }
            },
            updateComfortBid: {
                method: 'PUT',
                url:
                    config.monolithApi +
                    '/auctions/updateDayAheadOrderTemplate/:id',
                params: {
                    id: '@id'
                }
            },
            createComfortBid: {
                method: 'POST',
                url:
                    config.monolithApi +
                    '/auctions/submitDayAheadOrderTemplate',
                isArray: true
            },
            unifiedBids: {
                method: 'GET',
                url: config.monolithApi + '/auctions/:auctionId/unified-bids',
                isArray: true
            },
            report: {
                method: 'GET',
                url: config.monolithApi + '/auctions/report'
            },
            getAuctionCompetitions: {
                method: 'GET',
                url: config.monolithApi + '/auctions/:auctionId/competing',
                isArray: false
            },
            getReverseAuctions: {
                method: 'GET',
                url: config.monolithApi + '/auctions/reverse-auctions'
            },
            reverseAuctionsReport: {
                method: 'GET',
                url: config.monolithApi + '/auctions/reverse-auctions-report'
            },
            reverseAuctionBid: {
                method: 'POST',
                url: config.monolithApi + '/auctions/:auctionId/buyBack',
                params: {
                    bidId: '@bidId'
                }
            },
            capacityGraph: {
                method: 'GET',
                url:
                    config.monolithApi +
                    '/auctions/capacityGraph/:networkPointId',
                params: {
                    networkPointId: '@networkPointId'
                },
                isArray: true
            },
            comfortBidConfig: {
                method: 'GET',
                url: config.monolithApi + '/auctions/comfortBids/config'
            },
            orders: {
                method: 'GET',
                url: config.monolithApi + '/auctions/:auctionId/orders',
                isArray: true
            }
        }
    );
}

angular.module('app').factory('auctionResource', auctionResource);
